import { PublicCategoryDTO } from '../models/event';

/** Backend may return duplicate slugs; keep one entry per slug for stable React keys. */
export function dedupePublicCategoriesBySlug(
  categories: PublicCategoryDTO[],
): PublicCategoryDTO[] {
  const bySlug = new Map<string, PublicCategoryDTO>();

  for (const category of categories) {
    const existing = bySlug.get(category.slug);
    if (!existing || category.event_count > existing.event_count) {
      bySlug.set(category.slug, category);
    }
  }

  return Array.from(bySlug.values());
}
